import * as React from 'react';
import { Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, makeStyles } from '@fluentui/react-components';
import { tokens } from '@fluentui/react-components';
import { BackButton, NavigationProvider, Screen, routes } from '../hooks/routing';
import { LoginScreen } from '../screens/LoginScreen';
import { WelcomeScreen } from '../screens/WelcomeScreen';
import { StakeholderScreen } from '../screens/StakeholderScreen';
import { MainScreen } from '../screens/MainScreen';
import { ClientProvider, useClient } from '../hooks/client';
import { ArrowExitFilled } from '@fluentui/react-icons';
import ItemProvider from '../hooks/item/ItemProvider';
import { SummaryScreen } from '../screens/SummaryScreen';
import { Button } from './Button';
import { useTranslation } from 'react-i18next';

const useLayoutStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    background: tokens.colorNeutralBackground2,
    userSelect: 'none',
  },
  pageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
  },
  header: {
    backgroundColor: tokens.colorNeutralStrokeOnBrand,
    paddingInline: tokens.spacingHorizontalL,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalS,
  },
  logoutModal: {
    // Using margin rather than max-width to not have to override Fluents media query styles
    marginInline: tokens.spacingHorizontalS,
  },
});

const App = () => {
  const styles = useLayoutStyles();

  return (
    <NavigationProvider
      initialRoute="welcome"
      routes={routes}
    >
      <ClientProvider apiVersion="1.0">
        {({ isAuthenticated }) => (
          <div className={styles.container}>
            <header className={styles.header}>
              <BackButton />
            </header>

            <main className={styles.pageWrapper}>
              <Screen route="welcome">
                <WelcomeScreen />
              </Screen>
              <Screen route="login">
                <LoginScreen />
              </Screen>
              {isAuthenticated && (
                <ItemProvider>
                  <Screen route="main">
                    <MainScreen />
                  </Screen>
                  <Screen route="stakeholders">
                    <StakeholderScreen />
                  </Screen>
                </ItemProvider>
              )}
              <Screen route="summary">
                <SummaryScreen />
              </Screen>
            </main>
            <footer>{isAuthenticated && <LogOutButton />}</footer>
          </div>
        )}
      </ClientProvider>
    </NavigationProvider>
  );
};

const LogOutButton = () => {
  const { logout } = useClient();
  const styles = useLayoutStyles();
  const { t } = useTranslation();

  return (
    <>
      <Dialog modalType="alert">
        <DialogTrigger disableButtonEnhancement>
          <Button
            appearance="transparent"
            icon={<ArrowExitFilled />}
          />
        </DialogTrigger>
        <DialogSurface className={styles.logoutModal}>
          <DialogBody>
            <DialogTitle>{t('LAYOUT.LOGOUT_MODAL.TITLE')}</DialogTitle>
            <DialogContent>{t('LAYOUT.LOGOUT_MODAL.CONTENT')}</DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <Button appearance="secondary">{t('COMMON.CANCEL')}</Button>
              </DialogTrigger>
              <DialogTrigger disableButtonEnhancement>
                <Button
                  appearance="primary"
                  onClick={() => logout()}
                >
                  {t('LAYOUT.LOGOUT_MODAL.BUTTON')}
                </Button>
              </DialogTrigger>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
};

export default App;
